(function () {
  const VERSION = 'v9-single-regular-price-conversion';

  if (window.GLHCartAovController && typeof window.GLHCartAovController.destroy === 'function') {
    window.GLHCartAovController.destroy();
  }

  const listeners = [];
  const timers = new Set();

  function addListener(target, type, handler, options) {
    if (!target || !target.addEventListener) return;
    target.addEventListener(type, handler, options);
    listeners.push([target, type, handler, options]);
  }

  function later(fn, delay) {
    const id = window.setTimeout(function () {
      timers.delete(id);
      fn();
    }, delay);
    timers.add(id);
    return id;
  }

  function clearOwnedTimers() {
    timers.forEach(function (id) { window.clearTimeout(id); });
    timers.clear();
  }

  window.GLHCartAovController = {
    version: VERSION,
    destroy: function () {
      listeners.forEach(function (entry) {
        entry[0].removeEventListener(entry[1], entry[2], entry[3]);
      });
      listeners.length = 0;
      clearOwnedTimers();
    }
  };

  const PERSONALIZED_BOOKS = [
    {
      handle: 'a-personalized-scripture-book-written-over-your-child',
      title: 'Scripture Book',
      badge: 'Best Seller',
      description: 'Personalized scripture promises spoken over their name.',
      type: 'scripture'
    },
    {
      handle: 'a-personalized-bedtime-prayer-book-written-over-your-child',
      title: 'Bedtime Prayer Book',
      badge: 'New Prayer Book',
      description: "Personalized bedtime prayers to end the day with God's love.",
      type: 'bedtime_prayer'
    }
  ];

  const PERSONALIZED_HANDLES = PERSONALIZED_BOOKS.map(function (book) { return book.handle; });
  const FREE_SHIPPING_THRESHOLD = 9500;
  const SECOND_BOOK_COMPARE_PRICE = '$89.99';
  const SECOND_BOOK_DISCOUNT_PRICE = 'From $35';

  let aovUpdateTimer = null;
  let isConvertingDiscount = false;

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  }

  function formatMoney(cents) {
    const amount = Math.max(0, Number(cents) || 0) / 100;
    const fixed = amount.toFixed(2);
    return '$' + fixed.replace('.00', '');
  }

  function getCartAovCopy() {
    return Object.assign({
      buyTitle: 'Buy 2+ books and save 30%',
      readyText: 'Your extra book savings are ready. The first book stays full price, and each additional personalized book gets 30% off automatically.',
      addText: 'Add one more personalized book and get 30% off every extra book automatically.',
      buttonOpen: 'Choose another book and save 30%',
      invalidTitle: 'Regular-price book required',
      invalidText: 'The full-price first book was removed. Switch this book to regular price to continue checkout.',
      warningText: 'A full-price personalized book is required before discounted extra-book variants can be checked out.',
      convertButton: 'Keep this book at regular price',
      freeShippingLockedText: 'Free shipping unlocks when your order reaches $95.',
      freeShippingUnlockedTitle: 'Free shipping unlocked',
      freeShippingUnlockedText: 'Your order qualifies for free shipping.',
      popupEyebrow: 'This discount is only available right now.',
      popupTitle: 'Get 30% Off Another Personalized Book',
      popupText: 'Add another personalized book and save 30% today. Discount applied automatically.',
      popupNoThanks: 'No Thanks, Continue To Cart'
    }, window.GLH_CART_AOV_COPY || {});
  }

  function getRoot() {
    return document.querySelector('[data-cart-aov-block]');
  }

  function getItemProperties(item) {
    return item && item.properties ? item.properties : {};
  }

  function getItemBookHandle(item) {
    const properties = getItemProperties(item);
    return properties._personalizer_book || (item && item.handle) || PERSONALIZED_HANDLES[0];
  }

  function getItemName(item) {
    const properties = getItemProperties(item);
    return normalize(properties.Name || properties.name || properties['Child name'] || '');
  }

  function optionText(item) {
    const properties = getItemProperties(item);

    const optionPairs = Array.isArray(item && item.options_with_values)
      ? item.options_with_values.map(function (option) {
          return [option.name, option.value].join(' ');
        }).join(' ')
      : '';

    const variantOptions = Array.isArray(item && item.variant_options)
      ? item.variant_options.join(' ')
      : '';

    const options = Array.isArray(item && item.options)
      ? item.options.join(' ')
      : '';

    const propertyPairs = Object.keys(properties || {}).map(function (key) {
      return [key, properties[key]].join(' ');
    }).join(' ');

    return normalize([
      item && item.variant_title,
      item && item.title,
      item && item.product_title,
      optionPairs,
      variantOptions,
      options,
      propertyPairs
    ].join(' '));
  }

  function isPersonalizedItem(item) {
    const properties = getItemProperties(item);
    const propertyHandle = properties._personalizer_book || '';
    const productHandle = item && item.handle ? item.handle : '';

    return (
      PERSONALIZED_HANDLES.indexOf(propertyHandle) !== -1 ||
      PERSONALIZED_HANDLES.indexOf(productHandle) !== -1 ||
      Boolean(propertyHandle)
    );
  }

  function isExtraBookItem(item) {
    const properties = getItemProperties(item);
    const hidden = normalize(properties._extra_book_discount);
    const haystack = optionText(item);

    return hidden === 'yes' || /extra book|30%\s*off|30 off|extra-book/.test(haystack);
  }

  function hasOwnProperty(object, key) {
    return Object.prototype.hasOwnProperty.call(object || {}, key);
  }

  function isExplicitYes(value) {
    const normalized = normalize(value);
    return normalized === 'yes' || normalized === 'true' || normalized === '1' || normalized === 'y' || normalized === 'on';
  }

  function isExplicitNo(value) {
    const normalized = normalize(value);
    return normalized === 'no' || normalized === 'false' || normalized === '0' || normalized === 'n' || normalized === 'off' || normalized === '';
  }

  function variantOptionText(item) {
    const optionPairs = Array.isArray(item && item.options_with_values)
      ? item.options_with_values.map(function (option) {
          return [option.name, option.value].join(' ');
        }).join(' ')
      : '';

    const variantOptions = Array.isArray(item && item.variant_options)
      ? item.variant_options.join(' ')
      : '';

    const options = Array.isArray(item && item.options)
      ? item.options.join(' ')
      : '';

    return normalize([
      item && item.variant_title,
      item && item.title,
      item && item.product_title,
      item && item.sku,
      optionPairs,
      variantOptions,
      options
    ].join(' '));
  }

  function variantLooksLikeQrAudio(variant) {
    const text = normalize([
      variant && variant.title,
      variant && variant.name,
      variant && variant.option1,
      variant && variant.option2,
      variant && variant.option3,
      variant && variant.sku
    ].join(' '));

    return /qr|audio/.test(text);
  }

  function isQrAudioItem(item) {
    const properties = getItemProperties(item);

    if (hasOwnProperty(properties, '_qr_audio_addon')) {
      if (isExplicitYes(properties._qr_audio_addon)) return true;
      if (isExplicitNo(properties._qr_audio_addon)) return false;
    }

    if (hasOwnProperty(properties, 'QR Audio Add-on')) {
      if (isExplicitYes(properties['QR Audio Add-on'])) return true;
      if (isExplicitNo(properties['QR Audio Add-on'])) return false;
    }

    return /qr|audio/.test(variantOptionText(item));
  }

  function getPersonalizedItems(cart) {
    return (cart && cart.items ? cart.items : []).filter(isPersonalizedItem);
  }

  function countPersonalizedBooks(cart) {
    return getPersonalizedItems(cart).reduce(function (count, item) {
      return count + (Number(item.quantity) || 0);
    }, 0);
  }

  function getDiscountIntegrity(cart) {
    const personalizedItems = getPersonalizedItems(cart);
    const discountedItems = personalizedItems.filter(isExtraBookItem);
    const fullPriceItems = personalizedItems.filter(function (item) { return !isExtraBookItem(item); });

    const discountedQty = discountedItems.reduce(function (sum, item) {
      return sum + (Number(item.quantity) || 0);
    }, 0);

    const fullPriceQty = fullPriceItems.reduce(function (sum, item) {
      return sum + (Number(item.quantity) || 0);
    }, 0);

    return {
      personalizedItems: personalizedItems,
      discountedItems: discountedItems,
      fullPriceItems: fullPriceItems,
      discountedQty: discountedQty,
      fullPriceQty: fullPriceQty,
      hasInvalidDiscount: discountedQty > 0 && fullPriceQty < 1,
      hasBlockedCheckout: discountedQty > 0 && fullPriceQty < 1
    };
  }

  async function fetchCartJson() {
    const response = await fetch('/cart.js?glh_ts=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) throw new Error('Could not load cart.');
    return response.json();
  }

  async function fetchProductJson(handle) {
    const response = await fetch('/products/' + encodeURIComponent(handle) + '.js?glh_ts=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) throw new Error('Could not load product data.');
    return response.json();
  }

  function getNonDiscountVariantForItem(product, item) {
    const wantsQr = isQrAudioItem(item);
    const variants = Array.isArray(product && product.variants) ? product.variants : [];

    const exactCandidates = variants.filter(function (variant) {
      const text = normalize([
        variant.title,
        variant.name,
        variant.option1,
        variant.option2,
        variant.option3,
        variant.sku
      ].join(' '));

      const isDiscountVariant = /extra book|30%\s*off|30 off|extra-book/.test(text);
      const isQrVariant = /qr|audio/.test(text);

      if (isDiscountVariant) return false;
      return wantsQr ? isQrVariant : !isQrVariant;
    });

    if (exactCandidates[0]) return exactCandidates[0];

    return variants.find(function (variant) {
      const text = normalize([
        variant.title,
        variant.name,
        variant.option1,
        variant.option2,
        variant.option3,
        variant.sku
      ].join(' '));

      return !/extra book|30%\s*off|30 off|extra-book/.test(text);
    }) || variants[0] || null;
  }

  function buildConvertedProperties(item, variant) {
    const properties = Object.assign({}, getItemProperties(item));
    const convertsToQr = variantLooksLikeQrAudio(variant);

    properties._extra_book_discount = 'no';
    properties._personalizer_variant_id = String((variant && variant.id) || '');
    properties._personalizer_variant_title = String((variant && variant.title) || '');
    properties._personalizer_variant_sku = String((variant && variant.sku) || '');

    /*
      Preserve QR intent during invalid-discount conversion:
      - discounted no-QR -> regular no-QR
      - discounted QR -> regular QR

      Do not infer QR from technical property names like _qr_audio_page.
    */
    properties._qr_audio_addon = convertsToQr ? 'yes' : 'no';
    properties['QR Audio Add-on'] = convertsToQr ? 'Yes' : 'No';
    properties._qr_audio_page = convertsToQr ? 'page_01_qr' : 'page_01';
    properties._qr_audio_price = convertsToQr ? (properties._qr_audio_price || '$19') : '';
    properties._qr_audio_pricing_mode = 'product_variant';

    return properties;
  }

  function buildPersonalizerUrl(handle) {
    return '/pages/personalize-book?product=' + encodeURIComponent(handle) + '&source=second_book_upsell&extra_book_discount=yes';
  }

  function getConfiguredUpsellImage(book) {
    const images = window.GLH_SECOND_BOOK_UPSELL_IMAGES || {};
    return images[book.type] || images[book.handle] || '';
  }

  function getProductImage(product) {
    if (product && product.featured_image) return product.featured_image;
    if (product && Array.isArray(product.images) && product.images[0]) return product.images[0];
    return '';
  }

  function getStandardVariant(product) {
    const variants = Array.isArray(product && product.variants) ? product.variants : [];

    return variants.find(function (variant) {
      const text = normalize([
        variant.title,
        variant.name,
        variant.option1,
        variant.option2,
        variant.option3,
        variant.sku
      ].join(' '));

      return !/qr|audio|extra book|30%|30 off|extra-book/.test(text);
    }) || variants[0] || null;
  }

  function createSecondBookPriceMarkup() {
    return [
      '<span class="glh-second-book-card__price-current">' + escapeHtml(SECOND_BOOK_DISCOUNT_PRICE) + '</span>',
      '<span class="glh-second-book-card__price-compare">' + escapeHtml(SECOND_BOOK_COMPARE_PRICE) + '</span>'
    ].join('');
  }

  function buildBookCard(book) {
    const initialImage = getConfiguredUpsellImage(book);

    return [
      '<button type="button" class="glh-second-book-card" data-second-book-handle="' + escapeHtml(book.handle) + '">',
        '<span class="glh-second-book-card__badge">' + escapeHtml(book.badge) + '</span>',
        '<span class="glh-second-book-card__image-wrap" data-second-book-image-wrap="' + escapeHtml(book.handle) + '">',
          initialImage ? '<img src="' + escapeHtml(initialImage) + '" alt="" loading="lazy">' : '',
        '</span>',
        '<span class="glh-second-book-card__title">' + escapeHtml(book.title) + '</span>',
        '<span class="glh-second-book-card__description">' + escapeHtml(book.description) + '</span>',
        '<span class="glh-second-book-card__price" data-second-book-price-handle="' + escapeHtml(book.handle) + '">',
          createSecondBookPriceMarkup(book),
        '</span>',
        '<span class="glh-second-book-card__cta">Personalize this book</span>',
      '</button>'
    ].join('');
  }

  function closeCartUpsellModal() {
    document.querySelectorAll('[data-cart-second-book-modal]').forEach(function (modal) {
      modal.remove();
    });

    document.documentElement.classList.remove('glh-second-book-upsell-open');
  }

  async function hydrateUpsellModal(modal) {
    if (!modal) return;

    await Promise.all(PERSONALIZED_BOOKS.map(async function (book) {
      try {
        const product = await fetchProductJson(book.handle);
        const image = getConfiguredUpsellImage(book) || getProductImage(product);
        const variant = getStandardVariant(product);
        let originalCents = Number((variant && variant.price) || product.price || 0);

        if (originalCents > 0 && originalCents < 1000) {
          originalCents = originalCents * 100;
        }

        const imageWrap = modal.querySelector('[data-second-book-image-wrap="' + book.handle + '"]');
        if (imageWrap && image && !imageWrap.querySelector('img')) {
          imageWrap.innerHTML = '<img src="' + escapeHtml(image) + '" alt="" loading="lazy">';
        }

        const priceEl = modal.querySelector('[data-second-book-price-handle="' + book.handle + '"]');
        if (priceEl && originalCents > 0) {
          const discountedCents = Math.round(originalCents * 0.70);
          priceEl.innerHTML = [
            '<span class="glh-second-book-card__price-original">' + escapeHtml(formatMoney(originalCents)) + '</span>',
            '<span class="glh-second-book-card__price-discounted">' + escapeHtml(formatMoney(discountedCents)) + '</span>'
          ].join('');
        }
      } catch (error) {
        console.warn('Could not hydrate second-book upsell product', book.handle, error);
      }
    }));
  }

  function openCartUpsellModal() {
    closeCartUpsellModal();

    const copy = getCartAovCopy();
    const modal = document.createElement('div');
    modal.className = 'glh-second-book-upsell glh-second-book-upsell--cart-parity is-open';
    modal.setAttribute('data-cart-second-book-modal', '');
    modal.setAttribute('aria-hidden', 'false');

    modal.innerHTML = [
      '<div class="glh-second-book-upsell__backdrop" data-second-book-choice="cart"></div>',
      '<section class="glh-second-book-upsell__dialog" role="dialog" aria-modal="true" aria-labelledby="glh-cart-second-book-title">',
        '<p class="glh-second-book-upsell__eyebrow">' + escapeHtml(copy.popupEyebrow || 'This discount is only available right now.') + '</p>',
        '<h2 id="glh-cart-second-book-title" class="glh-second-book-upsell__title">' + escapeHtml(copy.popupTitle || 'Get 30% Off Another Personalized Book') + '</h2>',
        '<p class="glh-second-book-upsell__text">' + escapeHtml(copy.popupText || 'Add another personalized book and save 30% today. Discount applied automatically.') + '</p>',
        '<div class="glh-second-book-upsell__cards">',
          PERSONALIZED_BOOKS.map(buildBookCard).join(''),
        '</div>',
        '<button type="button" class="button button--primary glh-second-book-upsell__no-thanks" data-second-book-choice="cart">' + escapeHtml(copy.popupNoThanks || 'No Thanks, Continue To Cart') + '</button>',
      '</section>'
    ].join('');

    document.body.appendChild(modal);
    document.documentElement.classList.add('glh-second-book-upsell-open');

    modal.querySelectorAll('[data-second-book-handle]').forEach(function (button) {
      button.addEventListener('click', function () {
        const handle = button.getAttribute('data-second-book-handle');
        window.location.href = buildPersonalizerUrl(handle);
      });
    });

    modal.querySelectorAll('[data-second-book-choice], .glh-second-book-upsell__backdrop').forEach(function (el) {
      el.addEventListener('click', closeCartUpsellModal);
    });

    hydrateUpsellModal(modal);
  }

  function setCheckoutGuard(cart) {
    const integrity = getDiscountIntegrity(cart);
    const copy = getCartAovCopy();
    const buttons = Array.from(document.querySelectorAll(
      '#checkout, button[name="checkout"], [type="submit"][name="checkout"], .cart__checkout-button'
    ));

    buttons.forEach(function (button) {
      if (integrity.hasBlockedCheckout) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.dataset.glhDiscountGuard = 'true';
      } else if (button.dataset.glhDiscountGuard === 'true') {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        delete button.dataset.glhDiscountGuard;
      }
    });
  }

  function ensureAovElements(root) {
    if (!root) return;

    const firstCard = root.querySelector('.glh-cart-aov__card');
    if (!firstCard) return;

    let button = firstCard.querySelector('[data-cart-aov-upsell-trigger]');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'glh-cart-aov__button';
      button.setAttribute('data-cart-aov-upsell-trigger', 'open');
      button.textContent = getCartAovCopy().buttonOpen || 'Choose another book and save 30%';
      firstCard.appendChild(button);
    }

    let warning = firstCard.querySelector('[data-glh-discount-guard-message]');
    if (!warning) {
      warning = document.createElement('p');
      warning.className = 'glh-cart-aov__warning';
      warning.setAttribute('data-glh-discount-guard-message', '');
      warning.hidden = true;
      firstCard.appendChild(warning);
    }
  }

  function updateCartAovBlock(cart) {
    if (isConvertingDiscount) return;

    const root = getRoot();
    if (!root || !cart) return;

    root.hidden = !cart.item_count;
    ensureAovElements(root);
    setCheckoutGuard(cart);

    const cards = root.querySelectorAll('.glh-cart-aov__card');
    const buyCard = cards[0];
    const shippingCard = cards[1];
    const integrity = getDiscountIntegrity(cart);
    const copy = getCartAovCopy();

    if (buyCard) {
      const buyTitle = buyCard.querySelector('.glh-cart-aov__title');
      const buyText = buyCard.querySelector('.glh-cart-aov__text');
      const button = buyCard.querySelector('[data-cart-aov-upsell-trigger]');
      const warning = buyCard.querySelector('[data-glh-discount-guard-message]');
      const personalizedCount = countPersonalizedBooks(cart);

      buyCard.classList.toggle('is-invalid', Boolean(integrity.hasInvalidDiscount));

      if (integrity.hasInvalidDiscount) {
        if (buyTitle) {
          buyTitle.textContent = copy.invalidTitle || 'Regular-price book required';
        }

        if (buyText) {
          buyText.textContent = copy.invalidText || 'The full-price first book was removed. Switch this book to regular price to continue checkout.';
        }

        if (warning) {
          warning.hidden = false;
          warning.textContent = copy.warningText || 'A full-price personalized book is required before discounted extra-book variants can be checked out.';
        }

        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
          button.textContent = copy.convertButton || 'Keep this book at regular price';
          button.setAttribute('data-cart-aov-upsell-trigger', 'convert');
        }
      } else {
        if (buyTitle) {
          buyTitle.textContent = copy.buyTitle || 'Buy 2+ books and save 30%';
        }

        if (buyText) {
          buyText.textContent = personalizedCount >= 2
            ? (copy.readyText || 'Your extra book savings are ready. The first book stays full price, and each additional personalized book gets 30% off automatically.')
            : (copy.addText || 'Add one more personalized book and get 30% off every extra book automatically.');
        }

        if (warning) {
          warning.hidden = true;
          warning.textContent = '';
        }

        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
          button.textContent = getCartAovCopy().buttonOpen || 'Choose another book and save 30%';
          button.setAttribute('data-cart-aov-upsell-trigger', 'open');
        }
      }
    }

    if (shippingCard) {
      const title = shippingCard.querySelector('.glh-cart-aov__title');
      const text = shippingCard.querySelector('.glh-cart-aov__text');
      const fill = shippingCard.querySelector('.glh-cart-aov__bar-fill');
      const remaining = FREE_SHIPPING_THRESHOLD - cart.total_price;
      const progress = Math.max(0, Math.min(100, Math.round((cart.total_price / FREE_SHIPPING_THRESHOLD) * 100)));

      if (remaining > 0) {
        if (title) title.textContent = "You're " + formatMoney(remaining) + ' away from free shipping';
        if (text) text.textContent = copy.freeShippingLockedText || 'Free shipping unlocks when your order reaches $95.';
      } else {
        if (title) title.textContent = copy.freeShippingUnlockedTitle || 'Free shipping unlocked';
        if (text) text.textContent = copy.freeShippingUnlockedText || 'Your order qualifies for free shipping.';
      }

      if (fill) {
        fill.style.setProperty('--glh-progress', progress + '%');
      }
    }
  }

  async function fetchAndUpdateCartAov() {
    if (isConvertingDiscount) return;

    try {
      const cart = await fetchCartJson();
      updateCartAovBlock(cart);
    } catch (error) {
      console.warn('Cart AOV update failed', error);
    }
  }

  function scheduleCartAovUpdate() {
    if (isConvertingDiscount) return;

    if (aovUpdateTimer) {
      window.clearTimeout(aovUpdateTimer);
    }

    aovUpdateTimer = later(function () {
      aovUpdateTimer = null;
      fetchAndUpdateCartAov();
    }, 220);

    later(fetchAndUpdateCartAov, 900);
  }

  async function removeLineByKey(key) {
    if (!key) return false;

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    });

    return response.ok;
  }

  async function removeLineByNumber(line) {
    if (!line) return false;

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        line: line,
        quantity: 0
      })
    });

    return response.ok;
  }

  async function changeLineQuantityByKey(key, quantity) {
    if (!key) return false;

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: Math.max(0, Number(quantity) || 0)
      })
    });

    return response.ok;
  }

  async function changeLineQuantityByNumber(line, quantity) {
    if (!line) return false;

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        line: line,
        quantity: Math.max(0, Number(quantity) || 0)
      })
    });

    return response.ok;
  }

  function getDiscountedLineMatches(freshCart, originalItem) {
    const originalHandle = getItemBookHandle(originalItem);
    const originalName = getItemName(originalItem);
    const originalVariantId = String(originalItem && (originalItem.id || originalItem.variant_id) || '');

    const lines = (freshCart.items || []).map(function (lineItem, index) {
      return { item: lineItem, line: index + 1 };
    });

    return lines.filter(function (entry) {
      const candidate = entry.item;
      const candidateVariantId = String(candidate && (candidate.id || candidate.variant_id) || '');

      if (!isExtraBookItem(candidate)) return false;
      if (originalHandle && getItemBookHandle(candidate) !== originalHandle) return false;
      if (originalVariantId && candidateVariantId !== originalVariantId) return false;

      const candidateName = getItemName(candidate);
      if (originalName && candidateName && originalName !== candidateName) return false;

      return true;
    });
  }

  async function reduceMatchingDiscountedLineByOne(originalItem) {
    const originalQty = Math.max(1, Number(originalItem && originalItem.quantity) || 1);
    const nextQty = Math.max(0, originalQty - 1);

    if (originalItem && originalItem.key) {
      if (await changeLineQuantityByKey(originalItem.key, nextQty)) return true;
    }

    const freshCart = await fetchCartJson();
    const matches = getDiscountedLineMatches(freshCart, originalItem);

    if (!matches.length) return false;

    const match = matches[0];
    const matchQty = Math.max(1, Number(match.item && match.item.quantity) || 1);
    const nextMatchQty = Math.max(0, matchQty - 1);

    if (match.item && match.item.key && await changeLineQuantityByKey(match.item.key, nextMatchQty)) {
      return true;
    }

    return changeLineQuantityByNumber(match.line, nextMatchQty);
  }


  function setAovBusy(button, label) {
    const root = getRoot();
    isConvertingDiscount = true;
    document.documentElement.classList.add('glh-cart-converting-discount');
    if (root) root.classList.add('is-busy');

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.textContent = label || 'Updating cart...';
    }
  }

  function clearAovBusy(button, label) {
    const root = getRoot();
    isConvertingDiscount = false;
    document.documentElement.classList.remove('glh-cart-converting-discount');
    if (root) root.classList.remove('is-busy');

    if (button) {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      if (label) button.textContent = label;
    }
  }

  async function convertInvalidDiscountedItemsToFullPrice(button) {
    const originalLabel = button ? button.textContent : 'Keep this book at regular price';
    setAovBusy(button, 'Updating cart...');

    try {
      const cart = await fetchCartJson();
      const integrity = getDiscountIntegrity(cart);

      if (!integrity.hasInvalidDiscount || !integrity.discountedItems.length) {
        window.location.href = '/cart';
        return;
      }

      /*
        Business rule:
        At least one personalized book must be full price.
        If the first full-price book was removed, convert exactly ONE discounted unit
        back to the matching regular-price variant. Leave all other discounted books
        discounted.
      */
      const item = integrity.discountedItems[0];
      const handle = getItemBookHandle(item);
      const product = await fetchProductJson(handle);
      const variant = getNonDiscountVariantForItem(product, item);

      if (!variant || !variant.id) {
        throw new Error('Could not find a regular-price variant for this book.');
      }

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: variant.id,
          quantity: 1,
          properties: buildConvertedProperties(item, variant)
        })
      });

      if (!addResponse.ok) {
        throw new Error('Could not add the regular-price version.');
      }

      const reduced = await reduceMatchingDiscountedLineByOne(item);

      if (!reduced) {
        throw new Error('Could not reduce the discounted version.');
      }

      window.location.href = '/cart';
    } catch (error) {
      console.warn('Could not convert discounted book to regular price', error);
      clearAovBusy(button, originalLabel);
      scheduleCartAovUpdate();
    }
  }


  function handleCartAovAction(action, button) {
    if (isConvertingDiscount) return;

    const resolvedAction = String(action || (button && button.getAttribute('data-cart-aov-upsell-trigger')) || 'open');

    if (resolvedAction === 'convert') {
      convertInvalidDiscountedItemsToFullPrice(button);
      return;
    }

    openCartUpsellModal();
  }

  function handleAovTriggerClick(event, trigger) {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();

    const action = trigger ? trigger.getAttribute('data-cart-aov-upsell-trigger') : 'open';
    handleCartAovAction(action, trigger);
    return false;
  }

  window.GLHCartAovClick = handleAovTriggerClick;
  window.GLHCartOpenSecondBookUpsell = openCartUpsellModal;
  window.GLHCartHandleAovAction = handleCartAovAction;
  window.GLHCartRefreshAov = fetchAndUpdateCartAov;

  function onDocumentClick(event) {
    const trigger = event.target && event.target.closest
      ? event.target.closest('[data-cart-aov-upsell-trigger]')
      : null;

    if (trigger) {
      handleAovTriggerClick(event, trigger);
      return;
    }

    if (
      event.target.closest('cart-remove-button') ||
      event.target.closest('[id^="Remove-"]') ||
      event.target.closest('[href*="/cart/change"]') ||
      event.target.closest('[href*="/cart/update"]')
    ) {
      scheduleCartAovUpdate();
    }
  }

  function onCartEvent() {
    scheduleCartAovUpdate();
  }

  function onCartChange(event) {
    if (event.target && event.target.matches && event.target.matches('[name="updates[]"], .quantity__input')) {
      scheduleCartAovUpdate();
    }
  }

  function onDomReady() {
    fetchAndUpdateCartAov();

    const url = new URL(window.location.href);
    if (url.searchParams.get('open_second_book_upsell') === '1') {
      url.searchParams.delete('open_second_book_upsell');
      window.history.replaceState(
        {},
        '',
        url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash
      );
      later(openCartUpsellModal, 180);
    }
  }

  addListener(document, 'click', onDocumentClick, false);
  addListener(document, 'change', onCartChange, false);
  addListener(document, 'cart:updated', onCartEvent, false);
  addListener(document, 'cart:update', onCartEvent, false);
  addListener(document, 'shopify:section:load', onCartEvent, false);

  if (document.readyState === 'loading') {
    addListener(document, 'DOMContentLoaded', onDomReady, false);
  } else {
    onDomReady();
  }
})();
